/**
 * UX Sprint 2 — Single readiness pill.
 *
 * Status-driven coloring; small uppercase mono caption like the rest of
 * the dashboard. Used by ReadinessChips and the composite workspaces.
 */
import { Check, Loader2, AlertTriangle, CircleDot, Clock } from "lucide-react";

const ICONS = {
    approved: Check,
    in_progress: Loader2,
    needs_review: CircleDot,
    failed: AlertTriangle,
    not_started: Clock,
};

const CLASSES = {
    approved: "text-emerald-300 border-emerald-500/40 bg-emerald-500/5",
    in_progress: "text-amber-300 border-amber-500/40 bg-amber-500/5",
    needs_review: "text-sky-300 border-sky-500/40 bg-sky-500/5",
    failed: "text-red-300 border-red-500/40 bg-red-500/5",
    not_started: "text-zinc-500 border-zinc-800 bg-zinc-950",
};

const LABELS = {
    approved: "Ready",
    in_progress: "In Progress",
    needs_review: "Needs Review",
    failed: "Failed",
    not_started: "Missing",
};

export default function ReadinessPill({ status = "not_started", label, testid }) {
    const Icon = ICONS[status] || Clock;
    const cls = CLASSES[status] || CLASSES.not_started;
    return (
        <span
            data-testid={testid}
            data-status={status}
            className={`inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider px-2 py-1 rounded-sm border ${cls}`}
        >
            <Icon className={`w-3 h-3 ${status === "in_progress" ? "animate-spin" : ""}`} />
            {label || LABELS[status]}
        </span>
    );
}
